export class VendInfo {

    moduleType: string;
    location: string;
    value: number;
    displayText: string;
    maxInventory: number;
    currentInventory: number;

    fromJson(dict: any): VendInfo {
        this.moduleType = dict.moduleType;
        this.location = dict.location;
        this.value = dict.value;
        return this;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/vend-info.ts